import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34ba74fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_info" }
const _hoisted_3 = { class: "page_info_title blue" }
const _hoisted_4 = { class: "page_info_nr" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "物料信息：", -1))
const _hoisted_7 = { class: "item_nr" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "批次号：", -1))
const _hoisted_10 = { class: "item_nr" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "数量：", -1))
const _hoisted_13 = { class: "item_nr" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "工序：", -1))
const _hoisted_16 = { class: "item_nr" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "质量属性：", -1))
const _hoisted_19 = {
  key: 0,
  class: "item_nr green"
}
const _hoisted_20 = {
  key: 1,
  class: "item_nr yellow"
}
const _hoisted_21 = {
  key: 2,
  class: "item_nr red"
}
const _hoisted_22 = { class: "item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "所在仓库：", -1))
const _hoisted_24 = { class: "item_nr" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "所在货位：", -1))
const _hoisted_27 = { class: "item_nr" }
const _hoisted_28 = { class: "item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "返修工序：", -1))
const _hoisted_30 = { class: "item_nr" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "返修单号：", -1))
const _hoisted_33 = { class: "item_nr" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_title" }, "当前关联工单信息", -1))
const _hoisted_35 = {
  key: 0,
  class: "page_info"
}
const _hoisted_36 = { class: "page_info_title" }
const _hoisted_37 = {
  key: 0,
  class: "page_info_nr"
}
const _hoisted_38 = { class: "item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "物料编码：", -1))
const _hoisted_40 = { class: "item_nr" }
const _hoisted_41 = { class: "item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "开工日期：", -1))
const _hoisted_43 = { class: "item_nr" }
const _hoisted_44 = { class: "item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "批次号：", -1))
const _hoisted_46 = { class: "item_nr" }
const _hoisted_47 = { class: "item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "生产数量：", -1))
const _hoisted_49 = { class: "item_nr" }
const _hoisted_50 = { class: "item" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "生产设备：", -1))
const _hoisted_52 = { class: "item_nr" }
const _hoisted_53 = { class: "item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "生产人员：", -1))
const _hoisted_55 = { class: "item_nr" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  key: 1,
  class: "wu"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂未关联工单", -1))
const _hoisted_60 = [
  _hoisted_59
]

import { ref, onMounted } from 'vue'
    import { useRoute } from "vue-router"
    import { getListByCondition, queryById } from '@/apis/WorkOrderAPI'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()

    let gz_info = ref({})
    let gd_info = ref({})

    const getgz_Info = async (id: string): Promise<void> => {
        let res = await getListByCondition({ id })
        if (res.code === 200) {
            gz_info.value = res.data[0]
            if (res.data[0].workorderId) {
                getgd_Info(res.data[0].workorderId)
            }
        }
    }

    const getgd_Info = async (id: string): Promise<void> => {
        let res = await queryById(id)
        if (res.code === 200) {
            gd_info.value = res.data
        }
    }

    onMounted(() => {
        if (!route.query.id) return
        getgz_Info(route.query.id as string)
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(gz_info).code), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(gz_info).mmodelName) + " 丨 " + _toDisplayString(_unref(gz_info).mmodelCode), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(gz_info).batch), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(gz_info).num) + _toDisplayString(_unref(gz_info).umodelName), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(gz_info).pmodelName), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          (_unref(gz_info).qualityType === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, "合格"))
            : _createCommentVNode("", true),
          (_unref(gz_info).qualityType === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, "不良"))
            : _createCommentVNode("", true),
          (_unref(gz_info).qualityType === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, "报废"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(gz_info).whmodelName), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(gz_info).lmodelUnionName), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(gz_info).fxpmodelName ? _unref(gz_info).fxpmodelName : '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(gz_info).backorderId ? _unref(gz_info).backorderId : '-'), 1)
        ])
      ])
    ]),
    _hoisted_34,
    (JSON.stringify(_unref(gd_info)) !== '{}')
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(gd_info).code), 1),
          (_unref(gd_info).mmodel && _unref(gd_info).pgmodel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(gd_info).mmodel.code), 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(gd_info).planDate), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(gd_info).batch), 1)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(gd_info).planNum), 1)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(gd_info).pgmodel.name), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", _hoisted_55, [
                    (_unref(gd_info).proUserList && _unref(gd_info).proUserList.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(gd_info).proUserList, (item, index) => {
                          return (_openBlock(), _createElementBlock("span", { key: index }, [
                            _createTextVNode(_toDisplayString(item.proUserDepartName), 1),
                            _hoisted_56
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("span", _hoisted_57, "-"))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
  ]))
}
}

})